import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort',
  pure: true
})
export class SortPipe implements PipeTransform {
  transform(data: Array<any>, sortOptions: any): Array<any> {
    if (data && sortOptions.name) {
      const order = sortOptions.descending ? -1 : 1;
      const execption = sortOptions.exceptionValue;
      return data.sort(function (b1, b2) {
        if (sortOptions.exceptionName && execption) {
          if (
            b1[sortOptions.exceptionName] === execption &&
            b2[sortOptions.exceptionName] !== b1[sortOptions.exceptionName]
          ) {
            return -1 * order;
          } else if (
            b2[sortOptions.exceptionName] === execption &&
            b2[sortOptions.exceptionName] !== b1[sortOptions.exceptionNamec]
          ) {
            return 1 * order;
          }
        }
        if (b1[sortOptions.name] > b2[sortOptions.name]) {
          return 1 * order;
        }
        if (b1[sortOptions.name] < b2[sortOptions.name]) {
          return -1 * order;
        }
        return 0;
      });
    } else {
      return data;
    }
  }
}
